import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Summary from '../Summary';
import CouponForm from '../../containers/CouponFormContainer';
import SubPaymentMethodsSideContainer from '../../containers/PaymentMethods/SubPaymentMethodsSideContainer';

import { translate } from '../Translate';
import { FormattedMessage } from 'react-intl';
import { formatPricesByCountry } from '../../utils/products';
import { resolveLink } from '../../utils/links';
import { ProductType } from '../../enums';

const OrderSideComponent = (props) => {
  const { shoppingCart, productsToBuy, userData, hiddenCoupon = false, showSubPaymentMethods = false,
    planSubscription, subscriber, couponApply, setTotalPriceSummary, intl, couponVerifyError,
    termsAndConditionsUrl = '' } = props;
  const [productToBuyInfo] = productsToBuy;

  const handleShowPrice = () => {
    if (couponApply?.cycles && couponApply?.cyclesDuration === 'forever') {
      return productToBuyInfo?.discountPriceToShow;
    }
    if (couponApply?.cycles && !couponApply?.cyclesDuration === 'forever') {
      return productToBuyInfo?.priceToShow;
    }
    if (!couponApply?.cycles && couponApply?.duration === 'forever') {
      return productToBuyInfo?.discountPriceToShow;
    }
    return productToBuyInfo?.priceToShow;
  }

  const isAddOnEventProduct = useMemo(() => productToBuyInfo?.productType === ProductType.ADD_ON && productToBuyInfo?.event, [productToBuyInfo]);

  return (
    <>
      <div className="summary-content left">
        <Summary
          selectedProducts={shoppingCart.productsToBuy}
          isOnlyShowing
          isAddOnProduct={productToBuyInfo?.productType === ProductType.ADD_ON}
          title={translate(props.intl, 'Summary.dlocalForm.title')}
          subscriber={subscriber}
          couponApply={Object.entries(couponApply).length > 0 ? couponApply : {}}
          user={userData}
          setPriceToShow={setTotalPriceSummary}
          recurrenceToShow={productToBuyInfo && <FormattedMessage id={`MembershipSelectionPage.plan.trial.${productToBuyInfo?.interval?.unit}`} />}
          recurrenceToShowInsummary={productToBuyInfo && <FormattedMessage id={`MembershipSelectionPage.plan.small.cycles.${productToBuyInfo?.interval?.unit}`} />}
          priceToShow={productToBuyInfo && formatPricesByCountry(couponApply?.duration === 'forever' ? productToBuyInfo?.discountPriceToShow : productToBuyInfo?.priceToShow, userData?.country)}
        />
        {!hiddenCoupon && !planSubscription && <CouponForm subscription couponVerifyError={couponVerifyError} />}
        {(showSubPaymentMethods && props.isSingleSubscriptionClient) && <SubPaymentMethodsSideContainer />}
        <div className="subscription-policies text-start mt-3 text-white">
          {
            !isAddOnEventProduct && 
              <><p>
              <FormattedMessage
                id="MembershipSelectionPage.summary.plan.policies"
                values={{
                  recurrence: productToBuyInfo && <FormattedMessage id={`MembershipSelectionPage.plan.policies.${productToBuyInfo?.interval?.unit}`} />
                }} />
            </p><p>
                <FormattedMessage
                  id="MembershipSelectionPage.summary.plan.long.policies"
                  values={{
                    price: productToBuyInfo && formatPricesByCountry(handleShowPrice(), userData?.country),
                    planName: productToBuyInfo && productToBuyInfo?.name,
                    recurrence: productToBuyInfo && <FormattedMessage id={`MembershipSelectionPage.plan.policies.${productToBuyInfo?.interval?.unit}`} />
                  }} />
              </p><p>
                <FormattedMessage
                  id="MembershipSelectionPage.summary.plan.long.second.policies"
                  values={{
                    link: (
                      <a class="external_link" target="_blank" href={translate(intl, 'MembershipSelectionPage.summary.plan.long.second.policies.link')} rel="noreferrer">
                        <FormattedMessage id="MembershipSelectionPage.summary.plan.long.second.policies.name" />
                      </a>
                    )
                  }} />
              </p></>
          } 
          <p>
            <FormattedMessage id="MembershipSelectionPage.summary.plan.long.third.policies" />
          </p>
          <p>
            <FormattedMessage id="MembershipSelectionPage.summary.plan.long.four.policies"
              values={{
                terms: (
                  <a class="external_link" target="_blank" href={
                    resolveLink({
                      configuredUrl: termsAndConditionsUrl,
                      fallbackUrl: translate(intl, 'MembershipSelectionPage.summary.plan.term.link'),
                    })
                  } rel="noreferrer">
                    <FormattedMessage id="MembershipSelectionPage.summary.plan.term" />
                  </a>
                ),
                privacy: (
                  <a class="external_link" target="_blank" href={
                    translate(intl, 'MembershipSelectionPage.summary.plan.privacy.link')
                  } rel="noreferrer">
                    <FormattedMessage id="MembershipSelectionPage.summary.plan.privacy" />
                  </a>
                )
              }}
            />
          </p>
        </div>
      </div>
      {props.config && props.config.subscriptionHint &&
        <p className="disclaimer">
          <a
            style={{ color: 'black', textDecoration: 'none' }}
            href={props.config.subscriptionHint.url ? props.config.subscriptionHint.url : null}
          >{props.config.subscriptionHint.text}
          </a>
        </p>}
    </>
  );
}

const _existsSalePriceOffers = (productsToBuy) => {
  if (!productsToBuy || !Array.isArray(productsToBuy) || productsToBuy.length === 0) {
    return false;
  }

  return productsToBuy.some(product => {
    return product.salePriceOffers && Array.isArray(product.salePriceOffers) && product.salePriceOffers.length > 0
  });
}

OrderSideComponent.propTypes = {
  config: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  couponApply: PropTypes.object.isRequired,
  subscriber: PropTypes.object.isRequired,
  shoppingCart: PropTypes.array.isRequired,
  productsToBuy: PropTypes.array.isRequired,
  intl: PropTypes.object.isRequired,
  hiddenCoupon: PropTypes.bool.isRequired,
  showSubPaymentMethods: PropTypes.bool,
  isSingleSubscriptionClient: PropTypes.bool.isRequired,
  termsAndConditionsUrl: PropTypes.string,
};

OrderSideComponent.defaultProps = {
  termsAndConditionsUrl: '',
};

export default OrderSideComponent;
